import type { JSX } from 'react';

import { Glyph, type IconProps } from './Glyph';

/** Editing: adding, removing and sending — the glyphs that sit on buttons. */

export function MinusIcon(props: IconProps): JSX.Element {
  return (
    <Glyph {...props}>
      <path d="M5 12h14" />
    </Glyph>
  );
}

export function PlusIcon(props: IconProps): JSX.Element {
  return (
    <Glyph {...props}>
      <path d="M12 5v14M5 12h14" />
    </Glyph>
  );
}

export function TrashIcon(props: IconProps): JSX.Element {
  return (
    <Glyph {...props}>
      <g>
        <path d="M4 7h16M9.5 7V4.5h5V7" />
        <path d="M6.5 7l1 12.5h9L17.5 7" />
        <path d="M10.5 10.5v6M13.5 10.5v6" />
      </g>
    </Glyph>
  );
}

export function PaperclipIcon(props: IconProps): JSX.Element {
  return (
    <Glyph {...props}>
      <path d="M20 11.5 12 19.5a5 5 0 0 1-7-7l8.5-8.5a3.5 3.5 0 0 1 5 5l-8.5 8.5a2 2 0 0 1-3-3l8-8" />
    </Glyph>
  );
}

export function SendIcon(props: IconProps): JSX.Element {
  return (
    <Glyph {...props}>
      <g>
        <path d="M20.5 3.5 10.5 13.5" />
        <path d="M20.5 3.5 14 20.5l-3.5-7-7-3.5z" />
      </g>
    </Glyph>
  );
}

/** A message in a thread — the counter on «پیگیری‌های بی‌پاسخ». */
export function MessageIcon(props: IconProps): JSX.Element {
  return (
    <Glyph {...props}>
      <path d="M20.5 12.5a7.5 7.5 0 0 1-11 6.6L4 20.5l1.4-4.4A7.5 7.5 0 1 1 20.5 12.5Z" />
    </Glyph>
  );
}

/**
 * «تازه کردن» — an arrow that comes back round to where it started. Distinct
 * from `SpinnerIcon`: this one is still, and asks to be pressed.
 */
export function RefreshIcon(props: IconProps): JSX.Element {
  return (
    <Glyph {...props}>
      <g>
        <path d="M20 12a8 8 0 1 1-2.6-5.9" />
        <path d="M20.5 4v4.5H16" />
      </g>
    </Glyph>
  );
}

/** Reordering a list: one place earlier. Up and down read the same in RTL. */
export function ArrowUpIcon(props: IconProps): JSX.Element {
  return (
    <Glyph {...props}>
      <path d="M12 19V5M6 11l6-6 6 6" />
    </Glyph>
  );
}

/** Reordering a list: one place later. */
export function ArrowDownIcon(props: IconProps): JSX.Element {
  return (
    <Glyph {...props}>
      <path d="M12 5v14M6 13l6 6 6-6" />
    </Glyph>
  );
}

/** A picture — an image field with nothing in it yet. */
export function ImageIcon(props: IconProps): JSX.Element {
  return (
    <Glyph {...props}>
      <g>
        <rect height="15" rx="2.5" width="17" x="3.5" y="4.5" />
        <circle cx="9" cy="9.5" r="1.5" />
        <path d="m20.5 15.5-4.5-4.5-8.5 8.5" />
      </g>
    </Glyph>
  );
}

/** «پیام صوتی» — hold to record, in the staff chat. */
export function MicIcon(props: IconProps): JSX.Element {
  return (
    <Glyph {...props}>
      <g>
        <rect height="11" rx="3" width="6" x="9" y="3" />
        <path d="M5.5 11a6.5 6.5 0 0 0 13 0M12 17.5V21" />
      </g>
    </Glyph>
  );
}

/** Stop a recording. A filled square, so it reads as «stop» and not as a frame. */
export function StopIcon(props: IconProps): JSX.Element {
  return (
    <Glyph {...props}>
      <rect fill="currentColor" height="10" rx="1.5" width="10" x="7" y="7" />
    </Glyph>
  );
}
